// @flow
import type { TRootStore } from "../../types/index";

export const getDraftBar = (state: TRootStore) => state.cms.notification_bar_draft;